<template>
	<div>
		<el-card class="box-card">
			<div style="margin-bottom: 20px;">
				<el-form ref="queryForm" :model="queryParams" label-width="95px" inline size="small">
					<el-form-item label="运营商" v-if="isAdmin">
						<el-select v-model="queryParams.distributorId" placeholder="请选择" clearable filterable
							style="width: 180px;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="车锁编号">
						<el-input v-model="queryParams.bicycleNumber" placeholder="请输入" clearable
							style="width: 160px;" @keyup.enter.native="handleQuery" />
					</el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="queryParams.mobile" placeholder="请输入" clearable
							style="width: 150px;" @keyup.enter.native="handleQuery" />
					</el-form-item>
					<el-form-item label="服务单号">
						<el-input v-model="queryParams.serviceNo" placeholder="请输入" clearable
							style="width: 180px;" @keyup.enter.native="handleQuery" />
					</el-form-item>
					<el-form-item label="支付渠道">
						<el-select v-model="queryParams.payChannel" placeholder="请选择" clearable style="width: 120px;">
							<el-option label="微信" :value="1"></el-option>
							<el-option label="银联" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单状态">
						<el-select v-model="queryParams.status" placeholder="请选择" clearable style="width: 130px;">
							<el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker v-model="dateRange" type="daterange" range-separator="-"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" @change="handleDateChange">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>

			<el-table :data="orderList" border stripe v-loading="loading"
				:header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column label="运营商" prop="distributorName" show-overflow-tooltip />
				<el-table-column label="手机号" prop="mobile" width="120" />
				<el-table-column label="车锁编号" prop="bicycleNumber" width="150" show-overflow-tooltip />
				<el-table-column label="保险金额" prop="amount" width="100">
					<template slot-scope="scope">
						<span style="color: #F56C6C; font-weight: bold;">¥{{ formatAmount(scope.row.amount) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="支付渠道" prop="payChannel" width="90">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.payChannel === 1" type="success" size="small">微信</el-tag>
						<el-tag v-else-if="scope.row.payChannel === 2" type="warning" size="small">银联</el-tag>
						<span v-else></span>
					</template>
				</el-table-column>
				<el-table-column label="订单状态" prop="status" width="100">
					<template slot-scope="scope">
						<el-tag :type="getStatusType(scope.row.status)" :effect="getStatusEffect(scope.row.status)" size="small">
							{{ getStatusText(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="投保触发" prop="insureTriggerType" width="100">
					<template slot-scope="scope">
						{{ scope.row.insureTriggerType === 1 ? '立即投保' : (scope.row.insureTriggerType === 2 ? '延迟投保' : '-') }}
					</template>
				</el-table-column>
				<el-table-column label="服务单号" prop="serviceNo" width="170" show-overflow-tooltip />
				<!-- <el-table-column label="保单号" prop="policyNo" width="170" show-overflow-tooltip /> -->
				<el-table-column label="实际投保时间" prop="actualInsureTime" width="160">
					<template slot-scope="scope">{{ formatTime(scope.row.actualInsureTime) }}</template>
				</el-table-column>
				<el-table-column label="失败原因" prop="failReason" show-overflow-tooltip>
					<template slot-scope="scope">
						<span class="err-msg-cell" style="color: #F56C6C;" v-if="scope.row.failReason"
							@click="showErrDetail(scope.row.failReason)">{{ scope.row.failReason }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="createTime" width="160">
					<template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
				</el-table-column>
			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryParams.page" :page-sizes="[15, 25, 50, 100]"
				:page-size="queryParams.limit" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>

			<!-- 错误信息详情弹框 -->
			<el-dialog title="失败原因详情" :visible.sync="errDialogVisible" width="700px" append-to-body>
				<div class="err-detail-body">
					<el-input type="textarea" :value="errDialogContent" :rows="12" readonly
						resize="none"></el-input>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="copyErrContent">复 制</el-button>
					<el-button @click="errDialogVisible = false">关 闭</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			isAdmin: false,
			loading: false,
			dateRange: [],
			distributorOptions: [],
			distributorInfoList: [],
			orderList: [],
			total: 0,
			errDialogVisible: false,
			errDialogContent: '',
			statusOptions: [
				{ value: 0, label: '待支付' },
				{ value: 1, label: '待投保' },
				{ value: 2, label: '投保中' },
				{ value: 3, label: '投保成功' },
				{ value: 4, label: '投保失败' },
				{ value: 5, label: '已结束' },
				{ value: 8, label: '已取消' }
			],
			queryParams: {
				page: 1,
				limit: 15,
				distributorId: '',
				rechargeTradeNo: '',
				bicycleNumber: '',
				mobile: '',
				policyNo: '',
				serviceNo: '',
				status: null,
				payChannel: null,
				startDate: '',
				endDate: '',
				queryDistributorId: ''
			}
		}
	},
	created() {
		this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true';
		this.queryParams.queryDistributorId = getCurrentDistributorId();
		this.getDistributorOptions();
		this.getList();
		this.$root.$on('distributorChanged', this.handleDistributorChange);
	},
	beforeDestroy() {
		this.$root.$off('distributorChanged', this.handleDistributorChange);
	},
	methods: {
		handleDistributorChange(distributorId) {
			this.queryParams.queryDistributorId = distributorId || '';
			this.queryParams.page = 1;
			this.getList();
		},
		handleDateChange(val) {
			if (val) {
				this.queryParams.startDate = val[0];
				this.queryParams.endDate = val[1];
			} else {
				this.queryParams.startDate = '';
				this.queryParams.endDate = '';
			}
		},
		async getList() {
			this.loading = true;
			try {
				const { data: res } = await this.$http.post('/insurance/order/page', this.queryParams);
				if (res.code != 200) {
					this.$message.error(res.msg);
					return;
				}
				this.orderList = res.data.list;
				this.total = res.data.total;
			} catch (e) {
				this.$message.error('获取数据失败');
			} finally {
				this.loading = false;
			}
		},
		handleQuery() {
			this.queryParams.page = 1;
			this.getList();
		},
		resetQuery() {
			this.dateRange = [];
			this.queryParams = {
				page: 1,
				limit: this.queryParams.limit,
				distributorId: '',
				rechargeTradeNo: '',
				bicycleNumber: '',
				mobile: '',
				policyNo: '',
				serviceNo: '',
				status: null,
				payChannel: null,
				startDate: '',
				endDate: '',
				queryDistributorId: this.queryParams.queryDistributorId
			};
			this.getList();
		},
		handleSizeChange(pageSize) {
			this.queryParams.limit = pageSize;
			this.getList();
		},
		handleCurrentChange(pageNum) {
			this.queryParams.page = pageNum;
			this.getList();
		},
		getDistributorOptions() {
			this.$http.get('/distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = [];
				this.distributorInfoList = [];
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let list = res.data.data;
				for (let index in list) {
					this.distributorOptions.push({ key: list[index].id, value: list[index].name });
				}
				this.distributorInfoList = list;
			});
		},
		formatAmount(val) {
			if (val == null) return '0.00';
			return Number(val).toFixed(2);
		},
		formatTime(val) {
			if (!val) return '-';
			return val.replace('T', ' ').substring(0, 19);
		},
		getStatusText(status) {
			const item = this.statusOptions.find(i => i.value === status);
			return item ? item.label : '未知';
		},
		getStatusType(status) {
			switch (status) {
				case 0: return 'info';      // 待支付-灰色
				case 1: return 'warning';   // 待投保-橙色
				case 2: return 'warning';   // 投保中-橙色
				case 3: return 'success';   // 投保成功-绿色
				case 4: return 'danger';    // 投保失败-红色
				case 5: return 'success';   // 已结束-绿色
				case 6: return 'success';   // 分账成功-绿色
				case 7: return 'danger';    // 分账失败-红色
				case 8: return 'info';      // 已取消-灰色
				default: return 'info';
			}
		},
		getStatusEffect(status) {
			// plain: 初始/终止态（待支付、待投保、已取消）
			// 默认实心: 已进入流程的状态
			switch (status) {
				case 0:
				case 1:
				case 8:
					return 'plain';
				default:
					return 'dark';
			}
		},
		showErrDetail(msg) {
			if (!msg) return;
			this.errDialogContent = msg;
			this.errDialogVisible = true;
		},
		copyErrContent() {
			const text = this.errDialogContent;
			if (!text) return;
			if (navigator.clipboard) {
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success('已复制到剪贴板');
				}).catch(() => {
					this.fallbackCopy(text);
				});
			} else {
				this.fallbackCopy(text);
			}
		},
		fallbackCopy(text) {
			const ta = document.createElement('textarea');
			ta.value = text;
			ta.style.position = 'fixed';
			ta.style.opacity = '0';
			document.body.appendChild(ta);
			ta.select();
			try {
				document.execCommand('copy');
				this.$message.success('已复制到剪贴板');
			} catch (e) {
				this.$message.warning('复制失败，请手动选择文本复制');
			}
			document.body.removeChild(ta);
		}
	}
}
</script>

<style scoped>
.el-card {
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}

.el-table {
	margin-top: 15px;
	font-size: 12px;
}

.el-pagination {
	margin-top: 15px;
}

.err-msg-cell {
	display: inline-block;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	vertical-align: middle;
	cursor: pointer;
	border-bottom: 1px dashed #F56C6C;
}

.err-msg-cell:hover {
	background-color: #fef0f0;
}

.err-detail-body /deep/ .el-textarea__inner {
	font-family: Consolas, Monaco, "Courier New", monospace;
	font-size: 12px;
	line-height: 1.6;
	background-color: #fafafa;
	color: #F56C6C;
}
</style>
